import { SVGProps } from 'react'

export const Linkedin = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" fill="none" viewBox="0 0 25 24" {...props}>
    <g clipPath="url(#clip0_145_255)">
      <path
        fill="#05155E"
        d="M22.723 0H2.272C1.292 0 .5.773.5 1.73v20.536C.5 23.222 1.292 24 2.272 24h20.451c.98 0 1.777-.778 1.777-1.73V1.73C24.5.773 23.703 0 22.723 0zM7.62 20.452H4.058V8.995H7.62v11.457zM5.84 7.434a2.064 2.064 0 110-4.125 2.063 2.063 0 010 4.125zM20.95 20.452h-3.558v-5.57c0-1.326-.023-3.037-1.851-3.037-1.852 0-2.133 1.449-2.133 2.944v5.663H9.856V8.995h3.412v1.566h.047c.474-.9 1.636-1.852 3.366-1.852 3.605 0 4.27 2.372 4.27 5.457v6.286z"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_145_255">
        <path fill="#fff" d="M0 0H24V24H0z" transform="translate(.5)"></path>
      </clipPath>
    </defs>
  </svg>
)
